export const _URLS = {
  base: "https://be-ngram-counter.netlify.app/",
  getNgramCounts: ".netlify/functions/getNgramCounts",
};
